import axios, { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import { logAnalyticsEvent } from 'src/modules/analytics/analytics';
import type { StreakCheckinStreakBlock } from 'src/types/streak.types';
import { queryKeys } from 'src/queries/keys';

export type StreakCheckinResponse = {
  created: boolean;

  streak?: StreakCheckinStreakBlock;
};

export const useStreakCheckinMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<StreakCheckinResponse, AxiosError, void>({
    mutationFn: async () => {
      const { data } = await axios.post<StreakCheckinResponse>(
        '/api/user/streaks/checkin',
      );
      return data;
    },
    onSuccess: async data => {
      const invalidations: Promise<void>[] = [];
      if (data.created) {
        invalidations.push(
          queryClient.invalidateQueries(queryKeys.milestones()),
        );
      }
      if (data.created || data.streak) {
        invalidations.push(queryClient.invalidateQueries(queryKeys.streak()));
      }
      if (data.streak?.saved) {
        invalidations.push(queryClient.invalidateQueries(queryKeys.wallet()));
        void logAnalyticsEvent('streak_saved', {
          days_covered: data.streak.saved.days_covered,
          freezes_left: data.streak.saved.freezes_left,
          current_streak: data.streak.current_length,
        });
      }
      await Promise.all(invalidations);
    },
  });
};
